import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'
import Responsive from 'react-responsive';
import { Carousel } from '../../index'
import moment from 'moment'

import { media, breakpoints } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon, pageBackground } from '../../../styles/colors';
import { heading, paragraph } from '../../../styles/type';

class BlockJournal extends React.Component {

	state = {
	
	}

	getPosts = () => {
		const { articles } = this.props;

		return articles.map((article, i) => {
			return (
				<Post
					to={`/journal/${article.slug}`}
					key={i}
				>
					<Image
						image={article.hero_image.sizes.medium_large}
					/>
					<Info>
						<Title>{article.title}</Title>
						<MetaSection>
							{article.cats && article.cats.length > 0 && (
								<Meta>
									{article.cats[0].title}
								</Meta>
							)} 
						</MetaSection>
					</Info>
				</Post>
			)
		})
	}

	renderSlider = () => {
		return (
			<Carousel
				slides={this.getPosts()}
				ref={this.slider}
				styles={carouselStyles}
				settings={{
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					speed: 1000,
					arrows: false,
					dots: false,
					dragging: true,
					centerMode: true,
					centerPadding: '32px',
				}}
			/>
		)
	}

	renderPosts = () => {
		return (
			<Posts>
				{this.getPosts()}
			</Posts>
		)
	}
	
	render() {        
		return (
			<Wrapper>
				<Top>
					<Heading>Journal</Heading>
					<Button
						to={'/journal'}
					>
						View all posts
					</Button>
				</Top>

				{/* Projects Grid */}

				<Responsive minWidth={breakpoints.phone}>
					{this.renderPosts()}
				</Responsive>

				{/* Projects Slider */}

				<Responsive maxWidth={breakpoints.phone}>
					{this.renderSlider()}
				</Responsive>
			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	width: 1440px;
	max-width: 100%;
	padding: 0 15rem;
	box-sizing: border-box;
	position: relative;

	${media.tablet`
		padding: 0 10rem;
	`}

	${media.phone`
		padding: 0 40px;
	`}
`

const Heading = styled.div``
const Button = styled(Link)``

const Top = styled.div`
	position: relative;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 7.5rem;

	${media.phone`
		justify-content: space-between;
		margin-bottom: 40px;
	`}

	${Heading} {
		position: absolute;
		top: 1rem;
		left: 50%;
		transform: translateX(-50%);
		font-family: 'Scto';
		font-size: 24px;
		line-height: 24px;
		text-align: center;

		${media.laptop`
			font-size: 16px;
			line-height: 16px;
		`}

		${media.phone`
			position: static;
			transform: none;
			margin-top: 4px;
			text-align: left;
		`}
	}

	${Button} {
		height: 50px;
		padding-left: 20px;
		padding-right: 20px;
		font-family: 'Scto';
		font-size: 16px;
		background: rgba(255,255,255,0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		transition: background 0.25s ease;

		&:hover {
			background: rgba(255,255,255,1);
		}

		${media.laptop`
			font-size: 12px;
			height: 37px;
		`}
	}
`

const Posts = styled.div`
	display: flex;
	width: 100%;
`

// Project

const Post = styled(Link)`
	display: flex;
	flex-direction: column;
	flex: 0 1 33.3%;

	&:not(:last-child) {
		margin-right: 5rem;
	}

	${media.phone`
		margin: 0 10px;
	`}
`

const Image = styled.div`
	background-image: url(${props => props.image});
	${bgImage}
	background-color: #FFFFFF;
	background-size: contain;
	width: 100%;
	/* Fixed aspect ratio (3:4) so cards stay uniform without a fixed height that
	   would create letterbox borders when using contain. */
	height: 0;
	padding-bottom: 75%;
`

const Info = styled.div`
	background: ${pageBackground};
	padding: 2rem 3rem 3rem;
`

const Title = styled.div`
	${paragraph};
	text-indent: 0!important;
	margin-bottom: 2rem;
`

const MetaSection = styled.div`
	display: flex;

	> *:nth-child(2) {
		margin-left: 3px;
	}
`

const Meta = styled.div`
	font-family: 'Scto';
	font-size: 12px;
	color: #999999;
	opacity: 0.6;
	line-height: 12px;

	${media.tablet`
		font-size: 10.5px;
	`}
`

// Slider

const carouselStyles = css`
	position: relative;
	overflow: hidden;
	width: 100vw;
	transform: translateX(-40px);
`

BlockJournal.wrapper = css`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export default BlockJournal



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockJournal.js